import { FontFamily, FontWeight } from 'web-common/src/shared/styles';

/**
 * @deprecated The shef-web design system is being retired. Use `components/Button`
 *   from `web-common/src/shared/design-system` instead.
 * @see https://app.asana.com/0/0/1218340515107520
 */
export enum ButtonColors {
  DEFAULT = 'default',
  RED = 'red',
  GRAY = 'gray',
  LIGHT_GRAY = 'light_gray',
  DARK_GRAY = 'dark_gray',
  BLUE = 'blue',
  YELLOW = 'yellow',
  WHITE = 'white',
}

/**
 * @deprecated The shef-web design system is being retired. Use `components/Button`
 *   from `web-common/src/shared/design-system` instead.
 * @see https://app.asana.com/0/0/1218340515107520
 */
export enum ButtonSizes {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
}

/**
 * @deprecated The shef-web design system is being retired. Use `components/Button`
 *   from `web-common/src/shared/design-system` instead.
 * @see https://app.asana.com/0/0/1218340515107520
 */
export enum ButtonSelectStyles {
  BACKGROUND = 'BACKGROUND',
  BORDER = 'BORDER',
}

/**
 * @deprecated The shef-web design system is being retired. Use `components/Button`
 *   from `web-common/src/shared/design-system` instead.
 * @see https://app.asana.com/0/0/1218340515107520
 */
export interface ButtonProps {
  /** Color of the button. */
  color?: ButtonColors | string;
  /** Color of the button. */
  fontWeight?: FontWeight;
  /** If button is disabled. */
  disabled?: boolean;
  /** If the button is in error state. */
  error?: boolean;
  /** Auto sizes button width inside a flex container. */
  fluid?: boolean;
  /** If button is selected. */
  isSelected?: boolean;
  /** Size of the button. */
  size?: ButtonSizes;
  /** Font family of the button */
  fontFamily?: FontFamily;
  /** Selected style variant */
  selectedStyle?: ButtonSelectStyles;
}
